import * as _ from 'underscore';

import * as React from 'react';

import { Module } from '../Module';

export interface IToast {
  id: number;
  type: string;
  isClosed: boolean;
  lines?: string[];
  data?: any;
  timeoutDelay: number;
  timeout?: ng.IPromise<any>;
  /**
   * @deprecated trying to get rid of content since the shared ToastWidget does not support it
   */
  content?: React.ReactElement<any>;
  testId?: string;
  action?: () => void;
  actionMessage?: string;
}

export enum ToastType {
  Success,
  Info,
  Error,
  External,
  InfoNoFadeout,
  Warning
}

export interface IToastOptions {
  type: ToastType;
  text?: string;
  data?: any;
  timeoutDelay?: number;
  /**
   * @deprecated trying to get rid of content since the shared ToastWidget does not support it
   */
  content?: React.ReactElement<any>;
  testId?: string;
  action?: () => void;
  actionMessage?: string;
}

export interface IToastListener {
  toastsUpdated(toasts: IToast[]): void;
  id?: number;
}

export class ToasterService {

  public static NoTimeout = 0;

  private static DefaultTimeOutForInfo = 10 * 1000; // 10 seconds
  private static DefaultTimeOutForError = ToasterService.NoTimeout;

  private listeners: IToastListener[] = [];

  private $interval: ng.IIntervalService;
  private nextToastId: number = 0;

  public toasts: IToast[];

  private nextListenerId: number = 0;

  public static $inject = [ '$interval' ];

  constructor($interval: ng.IIntervalService) {
    this.$interval = $interval;
    this.toasts = [];
  }

  public pop(toastOptions: IToastOptions): number {

    const id = this.nextToastId ++;
    const toast: IToast = {
      id: id,
      type: ToastType[toastOptions.type].toLowerCase(),
      isClosed: false,
      lines: toastOptions.text ? toastOptions.text.split('\n') : undefined,
      data: toastOptions.data,
      timeoutDelay: toastOptions.timeoutDelay,
      content: toastOptions.content,
      testId: toastOptions.testId || 'tb-toast',
      action: toastOptions.action,
      actionMessage: toastOptions.actionMessage
    };
    toast.timeoutDelay = _.isNumber(toastOptions.timeoutDelay)
    ? toastOptions.timeoutDelay
      : this.defaultTimeoutForType(toastOptions.type);
    this.toasts.push(toast);

    this.notifyListeners();

    return toast.id;
  }

  public defaultTimeoutForType(toastType: ToastType) {
    return toastType === ToastType.Info ? ToasterService.DefaultTimeOutForInfo : ToasterService.DefaultTimeOutForError;
  }

  public notifyListeners() {
    _.each(this.listeners, (l) => l.toastsUpdated(this.toasts));
  }

  public close(id: number) {
    this.toasts = _.filter(this.toasts, (t) => t.id !== id);
    this.notifyListeners();
  }

  public addListener(listener: IToastListener): number {
    const listenerId = this.nextListenerId ++;
    listener.id = listenerId;
    this.listeners.push(listener);
    return listenerId;
  }

  public removeListener(id: number) {
    this.listeners = _.filter(this.listeners, (listener) => listener.id !== id);
  }

  // For 19.2 through 20.1 only
  public removeAllToasts() {
    this.toasts = [];
    this.notifyListeners();
  }
}

Module.instance().service('ToasterService', ToasterService);
